// extracted by mini-css-extract-plugin
export default {"description":"HPP3bK"};